import template from './smsTemplatesSharingPrivacy.html';
import SmsTemplatesSharingPrivacyCtrl from './smsTemplatesSharingPrivacyCtrl';

export default {
  template,
  controller: SmsTemplatesSharingPrivacyCtrl,
  controllerAs: 'vm',
};
